import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { stopDeal } from "services";

export const StopDealButton = observer(() => {
  const { actionModals, bidCard } = useStores();

  const stopDealHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          buttonText="Подтверждаю"
          text="Вы уверены, что хотите остановить сделку для проверки?"
          successText="Сделка остановлена"
          calledQuery={() => stopDeal({ id: bidCard.bid.id })}
        />
      ),
      {
        ...confirmationModalConfigs,
        title: "Остановка сделки",
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <CustomButton type="default" onClick={stopDealHandler}>
      Остановить сделку для проверки
    </CustomButton>
  );
});
